import { FC, FormEvent, useState } from 'react'
import { useDispatch } from 'react-redux'

import { closeModal } from 'store/actions/modals'
import { ProjectFormsProps } from '../types'
import { ConfirmCancelButtons } from '../ConfirmCancelButtons'

import { t } from 'translations'
import { useProjectSubmit } from './hooks'

export const StatusForm: FC<ProjectFormsProps> = ({ type, projectIds }) => {
  const dispatch = useDispatch()
  const submitStatus = useProjectSubmit('status')

  const statuses = [
    { name: t('manager.projects.STATUSES.CONFIRMED'), value: 'CONFIRMED' },
    { name: t('manager.projects.STATUSES.TENTATIVE'), value: 'TENTATIVE' },
    { name: t('manager.projects.STATUSES.CANCELLED'), value: 'CANCELLED' },
    { name: t('manager.projects.STATUSES.PLACEHOLDER'), value: 'PLACEHOLDER' },
    { name: t('manager.projects.STATUSES.COMPLETED'), value: 'COMPLETED' },
    { name: t('manager.projects.STATUSES.ARCHIVED'), value: 'ARCHIVED' }
  ]

  const [value, setValue] = useState<string>(statuses[0].value)

  if (type !== 'status') return null

  const disabledSubmit = value === '' || projectIds.length === 0

  const handleChange = (event: FormEvent<HTMLSelectElement>) => {
    setValue(event.currentTarget.value)
  }

  const handleSubmit = async () => {
    if (value === '') return
    await submitStatus({ projectIds: projectIds, status: value })
    dispatch(closeModal())
  }

  return (
    <>
      <div>{t('manager.projects.bulkEdit.STATUS.LABEL')}</div>
      <select className="custom-select my-2" value={value} onChange={handleChange}>
        {statuses.map((status, index) => (
          <option key={index} value={status.value}>
            {status.name}
          </option>
        ))}
      </select>
      <small className="mb-4 text-muted">{t('manager.projects.bulkEdit.STATUS.DESCRIPTION')}</small>
      <ConfirmCancelButtons handleSubmit={handleSubmit} disabled={disabledSubmit} />
    </>
  )
}
